var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGooglePlayDark = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 21,
  height: 21,
  viewBox: "0 0 21 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 21.708V2.292C0 1.618.388 1.024.96.75L12.21 12 .96 23.25A1.722 1.722 0 0 1 0 21.708Zm15.773-6.145-12.29 7.104 9.697-9.696 2.593 2.592Zm3.826-4.922c.388.308.674.788.674 1.359s-.251 1.028-.651 1.348l-2.616 1.507L14.151 12l2.855-2.855L19.6 10.64ZM3.483 1.332l12.29 7.105-2.593 2.592-9.697-9.697Z",
  fill: "#fff"
})));
export default SvgGooglePlayDark;